<template>
  <div class="order-form-layout" v-bind:class="{'show' : isActive}">
    <BookingForm
      v-if="bookingType === 'BOOKING'"
      @closed="closeForm"
      @completed="sendOrder"
      :isActive="bookingType === 'BOOKING'">
    </BookingForm>
    <EventForm
      v-if="this.bookingData && bookingType === 'EVENT'"
      @closed="closeForm"
      @completed="sendOrder"
      :id="this.bookingData.id"
      :title="this.bookingData.title"
      :dateStart="this.bookingData.dateStart"
      :price="this.bookingData.price"
      :isActive="bookingType === 'EVENT'">
    </EventForm>
    <EventCinemaForm
      v-if="this.bookingData && bookingType === 'EVENT-CINEMA'"
      :isActive="bookingType === 'EVENT-CINEMA'"
      :payload="this.bookingData"
      @closed="closeForm"
      @completed="sendOrder">

    </EventCinemaForm>
    <div class="complete-wrapper" v-bind:class="{'show animate__animated animate__fadeInRight' : isShowCompleteModal}">
      <div class="complete-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
          <rect x="4" y="4" width="48" height="48" rx="24" fill="#D1FADF"/>
          <rect x="4" y="4" width="48" height="48" rx="24" stroke="#ECFDF3" stroke-width="8"/>
          <path d="M38 27.0801V28.0001C37.9988 30.1565 37.3005 32.2548 36.0093 33.9819C34.7182 35.7091 32.9033 36.9726 30.8354 37.584C28.7674 38.1954 26.5573 38.122 24.5345 37.3747C22.5117 36.6274 20.7847 35.2462 19.611 33.4372C18.4373 31.6281 17.8798 29.4882 18.0217 27.3364C18.1636 25.1847 18.9972 23.1364 20.3983 21.4972C21.7994 19.8579 23.6928 18.7155 25.7962 18.2403C27.8996 17.765 30.1003 17.9824 32.07 18.8601M38 20.0001L28 30.0101L25 27.0101" stroke="#039855" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="complete-title">
        Проверьте свою почту.
      </div>
      <div class="complete-description">
        Мы отправили ссылку подтверждения на  <br/> <b>{{ mail }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import IconInput from '../Inputs/IconInput.vue'
import CustomButton from '../Inputs/CustomButton.vue'
import {EventBus} from '@/eventBus'
import BookingForm from './BookingForm.vue'
import EventForm from './EventForm.vue'
import EventCinemaForm from './EventCinemaForm.vue'

export default {
  name: 'OrderFormLayout',
  components: {EventCinemaForm, EventForm, BookingForm, CustomButton, IconInput},
  created: function () {
    EventBus.$on('openForm', this.openForm)
  },
  beforeDestroy: function () {
    EventBus.$off('openForm', this.openForm)
  },
  data () {
    return {
      isActive: false,
      isShowCompleteModal: false,
      bookingData: null,
      bookingType: '',
      mail: ''
    }
  },
  methods: {
    closeForm () {
      this.isActive = false
    },
    openForm (data) {
      this.bookingType = data.bookingType
      this.bookingData = data.bookingData
      this.isActive = true
    },
    sendOrder (mail) {
      this.isShowCompleteModal = true
      this.mail = mail

      setTimeout(() => {
        window.location.reload()
      }, 5000)
    }
  }
}
</script>

<style>
.order-form-layout {
  opacity: 0;
  animation: ani 0.5s forwards;
  z-index: 9999;
  display: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(52, 64, 84, 0.20);
  backdrop-filter: blur(10px);
}

.order-form-layout.show {
  display: flex;
}

@keyframes ani {
  0% {opacity: 0;}
  100% {opacity: 1;}
}

.complete-wrapper {
  display: none;
  padding: 24px 48px;
  flex-direction: column;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0 8px 8px -4px rgba(16, 24, 40, 0.03), 0 20px 24px -4px rgba(16, 24, 40, 0.08);
}

.complete-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}

.complete-title {
  display: flex;
  justify-content: center;
  color: #101828;
  text-align: center;
  padding-bottom: 8px;
  /* Text lg/Medium */
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 155.556% */
}

.complete-description {
  text-align: center;
  color: #344054;

  /* Text sm/Semibold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.complete-wrapper.show {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/client/Forms/OrderFormLayout.vue